import apiSlice, { providesList } from "../../app/api/apiSlice";

export const userApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getCurrentCompanyUsers: builder.query({
			query: () => `/api/company/users`,
			transformResponse: (response) => {
				return response.data.map((d, index) => {
					return { lp: index + 1, ...d };
				});
			},
			providesTags: (result) => providesList(result?.data || null, "Users"),
		}),
		getCompanyWithIdUsers: builder.query({
			query: (companyId) => `/api/company/${companyId}/users`,
			transformResponse: (response) => {
				return response.data.map((d, _index) => {
					return { ...d };
				});
			},
			providesTags: (result) => providesList(result?.data || null, "Users"),
		}),
		getCurrentUser: builder.query({
			query: () => `/api/user`,
			providesTags: (result, _error) => {
				const id = result?.id;
				return [
					{ type: "Users", id: "LIST" },
					{ type: "Users", id },
					{ type: "MailingIntegration", id: "LIST" },
				];
			},
		}),
		getUserWithId: builder.query({
			query: (userId) => `/api/user/${userId}`,
			providesTags: (result, error, id) => {
				return [
					{ type: "Users", id: "LIST" },
					{ type: "Users", id },
				];
			},
		}),
		updateCurrentUser: builder.mutation({
			query: (data) => ({
				url: `/api/user`,
				method: "PUT",
				body: { ...data },
			}),
			invalidatesTags: [
				{ type: "Users", id: "LIST" },
				{ type: "CompanyCargos", id: "LIST" },
				{ type: "CompanyStats", id: "GENERAL_LIST" },
				{ type: "CompanyAdmins", id: "LIST" },
			],
		}),
		updateUserWithId: builder.mutation({
			query: ({ userId, data }) => ({
				url: `/api/user/${userId}`,
				method: "PUT",
				body: { ...data },
			}),
			invalidatesTags: [
				{ type: "Users", id: "LIST" },
				{ type: "CompanyCargos", id: "LIST" },
				{ type: "CompanyStats", id: "GENERAL_LIST" },
				{ type: "CompanyAdmins", id: "LIST" },
			],
		}),
		removeUserWithId: builder.mutation({
			query: ({ userId }) => ({
				url: `/api/user/${userId}`,
				method: "DELETE",
			}),
			invalidatesTags: [
				{ type: "Users", id: "LIST" },
				{ type: "CompanyCargos", id: "LIST" },
				{ type: "CompanyStats", id: "GENERAL_LIST" },
				{ type: "CompanyAdmins", id: "LIST" },
			],
		}),
		addUserToCompany: builder.mutation({
			query: ({ companyId, data }) => ({
				url: `/api/company/${companyId}/user`,
				method: "POST",
				body: { ...data },
			}),
			invalidatesTags: [
				{ type: "Users", id: "LIST" },
				{ type: "CompanyStats", id: "GENERAL_LIST" },
				{ type: "CompanyAdmins", id: "LIST" },
			],
		}),
		getUsersChangeLog: builder.query({
			query: ({ company }) => `/api/users/changeLog?company=${company}`,
			providesTags: (_result) => {
				return [{ type: "UsersChangelog", id: "LIST" }];
			},
		}),
		acceptUsersChangeLogWithId: builder.mutation({
			query: ({ changeId }) => ({
				url: `/api/users/changeLog/change/${changeId}`,
				method: "PUT",
			}),
			invalidatesTags: [{ type: "UsersChangelog", id: "LIST" }],
		}),
		resetIntegrationStatuses: builder.mutation({
			query: () => ({
				url: `/api/user/resetDisconnect`,
				method: "POST",
			}),
			invalidatesTags: [{ type: "Integrations", id: "LIST" }],
		}),
	}),
	overrideExisting: true,
});

export const {
	useGetCurrentUserQuery,
	useGetUserWithIdQuery,
	useUpdateCurrentUserMutation,
	useUpdateUserWithIdMutation,
	useRemoveUserWithIdMutation,
	useAddUserToCompanyMutation,
	useGetCurrentCompanyUsersQuery,
	useGetCompanyWithIdUsersQuery,
	useGetUsersChangeLogQuery,
	useAcceptUsersChangeLogWithIdMutation,
	useResetIntegrationStatusesMutation,
} = userApiSlice;
